var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouWasteManagment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    "data-name": "inom avfall",
    transform: "translate(1.37 1.067)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M18.84 36.418h24.212V60.63H18.84z",
    "data-name": "Rectangle 14447"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m38.477 36.418-7.533 7.017-7.533-7.017",
    "data-name": "Path 40231"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M18.798 49.659h24.253",
    "data-name": "Line 4371"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M18.798 55.175h24.253",
    "data-name": "Line 4372"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.51 25.201c2.108 1.219 4.067 1.706 5.668.44",
    "data-name": "Path 40232"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.411,
    cy: 0.411,
    r: 0.411,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Ellipse 750",
    transform: "translate(25.008 17.412)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m32.255 14.169 14.223 4.453S51.049 5.165 37.122.845c-9.576-2.97-14.277 2.566-16.28 6.316 0 0-9.685-3.51-10.62-1.638s8.512 4.428 22.033 8.646Z",
    "data-name": "Path 40233"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M31.223 3.9c3.326-.951 8.483 1.556 10.643 4.205",
    "data-name": "Path 40234"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m43.161 39.063 8.7 9.194 1.833 9.884",
    "data-name": "Path 40235"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m18.56 39.063-8.7 9.194-9.859-5.854",
    "data-name": "Path 40236"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m25.092 60.787-2.939 11.6-.21 6.733",
    "data-name": "Path 40237"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.848 87.555v-8.229h8.229v8.229",
    "data-name": "Path 40238"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.848 87.555h-4.49a1.912 1.912 0 0 0-1.912 1.912v3.575h14.63v-5.488",
    "data-name": "Path 40239"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.366,
    cy: 0.366,
    r: 0.366,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Ellipse 751",
    transform: "translate(12.453 93.122)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.366,
    cy: 0.366,
    r: 0.366,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Ellipse 752",
    transform: "translate(14.83 93.122)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.366,
    cy: 0.366,
    r: 0.366,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Ellipse 753",
    transform: "translate(17.208 93.122)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.366,
    cy: 0.366,
    r: 0.366,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Ellipse 754",
    transform: "translate(19.586 93.122)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.366,
    cy: 0.366,
    r: 0.366,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Ellipse 755",
    transform: "translate(21.963 93.122)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.366,
    cy: 0.366,
    r: 0.366,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Ellipse 756",
    transform: "translate(24.34 93.122)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M35.795 87.603v-8.229h8.229v8.229",
    "data-name": "Path 40240"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M35.795 87.603v5.488h14.631v-3.575a1.912 1.912 0 0 0-1.912-1.912h-4.488",
    "data-name": "Path 40241"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.366,
    cy: 0.366,
    r: 0.366,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Ellipse 757",
    transform: "translate(48.688 93.169)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.366,
    cy: 0.366,
    r: 0.366,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Ellipse 758",
    transform: "translate(46.31 93.169)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.366,
    cy: 0.366,
    r: 0.366,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Ellipse 759",
    transform: "translate(43.933 93.169)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.366,
    cy: 0.366,
    r: 0.366,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Ellipse 760",
    transform: "translate(41.556 93.169)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.366,
    cy: 0.366,
    r: 0.366,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Ellipse 761",
    transform: "translate(39.178 93.169)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.366,
    cy: 0.366,
    r: 0.366,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Ellipse 762",
    transform: "translate(36.8 93.169)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m36.707 60.851 2.939 11.6.21 6.732",
    "data-name": "Path 40242"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m30.741 19.487 12.784 2.875",
    "data-name": "Line 4373"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m19.879 16.729 1.854.458",
    "data-name": "Line 4374"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m30.025 21.794-8.134-1.675 1.2-5.684 8.133 1.675Z",
    "data-name": "Path 40243"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M22.359 11.282a12.142 12.142 0 1 0 21.647 7.555c0-.191 0-.383-.013-.573",
    "data-name": "Path 40244"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouWasteManagment);
export default __webpack_public_path__ + "static/media/youWasteManagment.72a7d06ff66bc79d9f438e3728e0a37c.svg";
export { ForwardRef as ReactComponent };